import connection from "../../utils/connection";

const getLogout = async () => {
  let response = {};
  try {
    const responseGet = await connection({
      method: "POST",
      url: "/login/logout",
    });

    response = responseGet;
  } catch (error) {
    console.error("catch service", error);
    response = error.response;
  }

  return response;
};

export default getLogout;
